import { useState, useRef, useEffect, useCallback } from 'react';

export default function Magnet({
  children,
  padding = 90,
  disabled = false,
  magnetStrength = 3,
  className = '',
}) {
  const [pos, setPos] = useState({ x: 0, y: 0 });
  const [active, setActive] = useState(false);
  const ref = useRef(null);

  const supported = useCallback(
    () =>
      typeof matchMedia !== 'undefined' &&
      matchMedia('(hover: hover)').matches &&
      !matchMedia('(prefers-reduced-motion: reduce)').matches,
    []
  );

  useEffect(() => {
    if (disabled) return undefined;

    const handleMove = (e) => {
      const el = ref.current;
      if (!el || !supported()) return;
      const rect = el.getBoundingClientRect();
      const cx = rect.left + rect.width / 2;
      const cy = rect.top + rect.height / 2;
      const dx = e.clientX - cx;
      const dy = e.clientY - cy;

      if (Math.abs(dx) < rect.width / 2 + padding && Math.abs(dy) < rect.height / 2 + padding) {
        setActive(true);
        setPos({ x: dx / magnetStrength, y: dy / magnetStrength });
      } else {
        setActive(false);
        setPos({ x: 0, y: 0 });
      }
    };

    window.addEventListener('pointermove', handleMove);
    return () => window.removeEventListener('pointermove', handleMove);
  }, [padding, disabled, magnetStrength, supported]);

  return (
    <span
      ref={ref}
      className={`rb-magnet ${className}`}
      style={{
        display: 'inline-block',
        transform: `translate3d(${pos.x}px, ${pos.y}px, 0)`,
        transition: active ? 'transform 0.1s ease-out' : 'transform 0.5s cubic-bezier(0.16,1,0.3,1)',
      }}
    >
      {children}
    </span>
  );
}
